export const navigationConstant = {
    OPEN_SIDE_BAR: "OPEN_SIDE_BAR",
    CLOSE_SIDE_BAR: "CLOSE_SIDE_BAR",
}